import { Routes } from "@angular/router";
import { authGuard } from "../guards/auth.guard"; // Importar o authGuard funcional
import { hasAccessGuard } from "../guards/has-access.guard";
import { organizerResolver } from "../resolvers/organizer.resolver";
import { LoadingComponent } from "../shared/components/loading/loading.component";
import { PageNotFoundComponent } from "../shared/components/page-not-found/page-not-found.component";
import { ProducerAreaComponent } from "../shared/components/producer-area/producer-area.component";
import { WalletComponent } from "../shared/components/wallet/wallet.component";
import { AboutUsComponent } from "./pages/about-us/about-us.component";
import { CartComponent } from "./pages/cart/cart.component";
import { CollaboratorsAcceptanceComponent } from "./pages/collaborators-acceptance/collaborators-acceptance.component";
import { CollaboratorsInvitationSuccessPageComponent } from "./pages/collaborators-invitation-success-page/collaborators-invitation-success-page.component";
import { CompraRealizadaComponent } from "./pages/compra-realizada/compra-realizada.component";
import { CreateProducersPageComponent } from "./pages/create-producers-page/create-producers-page.component";
import { EventSearchComponent } from "./pages/event-search/event-search.component";
import { CreateEventContainerComponent } from "./pages/events/create-event-container/create-event-container.component";
import { EditEventContainerComponent } from "./pages/events/edit-event-container/edit-event-container.component";
import { EventDetailsContainerComponent } from "./pages/events/event-details-container/event-details-container.component";
import { EventsListContainerComponent } from "./pages/events/events-list-container/events-list-container.component";
import { MyEventsPageComponent } from "./pages/events/my-events-page/my-events-page.component";
import { MyFavoriteEventsContainerComponent } from "./pages/events/my-favorite-events-container/my-favorite-events-container.component";
import { FinishSignUpPageComponent } from "./pages/finish-sign-up-page/finish-sign-up-page.component";
import { FollowedProducersPageComponent } from "./pages/followed-producers-page/followed-producers-page.component";
import { FrequentlyAskedQuestionsComponent } from "./pages/frequently-asked-questions/frequently-asked-questions.component";
import { HalfPriceComponent } from "./pages/half-price/half-price.component";
import { HomeComponent } from "./pages/home/home.component";
import { MyInvitationsPageComponent } from "./pages/my-invitations-page/my-invitations-page.component";
import { NotificationsPageComponent } from "./pages/notifications-page/notifications-page.component";
import { ManageCardsComponent } from "./pages/manage-cards/manage-cards.component";
import { MyOrdersComponent } from "./pages/my-orders/my-orders.component";
import { MySalesPageComponent } from "./pages/my-sales-page/my-sales-page.component";
import { OrderCheckoutComponent } from "./pages/order-checkout/order-checkout.component";
import { PrivacyPolicyComponent } from "./pages/privacy-policy/privacy-policy.component";
import { ProducerEventPageComponent } from "./pages/producer-event-page/producer-event-page.component";
import { ProducersPageComponent } from "./pages/producers-page/producers-page.component";
import { RecoveryPasswordComponent } from "./pages/recovery-password/recovery-password.component";
import { TalkToUsComponent } from "./pages/talk-to-us/talk-to-us.component";
import { TermsOfUseComponent } from "./pages/terms-of-use/terms-of-use.component";
import { SolicitationsPageComponent } from "./pages/solicitations-page/solicitations-page.component";
import { SolicitationDetailPageComponent } from "./pages/solicitation-detail-page/solicitation-detail-page.component";
import { SupportPageComponent } from "./pages/support-page/support-page.component";
import { SupportDetailPageComponent } from "./pages/support-detail-page/support-detail-page.component";
import { CouponDetailPageComponent } from "./pages/coupon-detail-page/coupon-detail-page.component";
import { WelcomePageComponent } from "./pages/welcome-page/welcome-page.component";
import { SellerEventsPageComponent } from "./pages/seller-events/seller-events-page.component";
import { SellerOrdersPageComponent } from "./pages/seller-events/seller-orders-page.component";

export const routes: Routes = [
  {
    title: "Yes7 - Página Inicial",
    path: "",
    component: HomeComponent,
  },
  {
    title: "Carregando...",
    path: "loading",
    component: LoadingComponent,
  },
  {
    title: "Yes7 - Evento",
    path: "event/:id",
    component: EventDetailsContainerComponent,
  },
  {
    title: "Yes7 - Busca de eventos",
    path: "event-search/:searchParams",
    component: EventSearchComponent,
  },
  {
    title: "Yes7 - Welcome",
    path: "welcome",
    component: WelcomePageComponent,
  },
  {
    title: "Yes7 - Carrinho",
    path: "cart",
    component: CartComponent,
    canActivate: [authGuard],
  },
  {
    path: "account",
    children: [
      {
        title: "Edit Password",
        path: "password/edit",
        component: RecoveryPasswordComponent,
      },
      {
        title: "Confirmation",
        path: "confirmation",
        component: WelcomePageComponent,
      },
    ],
  },
  {
    title: "Yes7 - Meus ingressos",
    path: "my-orders",
    component: MyOrdersComponent,
    canActivate: [authGuard],
  },
  {
    title: "Yes7 - Finalizar Pagamento",
    path: "order-checkout/:orderId",
    component: OrderCheckoutComponent,
    canActivate: [authGuard],
  },
  {
    title: "Yes7 - Compra realizada",
    path: "checkout-success",
    component: CompraRealizadaComponent,
    canActivate: [authGuard],
  },
  {
    title: "Yes7 - Política de Privacidade",
    path: "privacy-policy",
    component: PrivacyPolicyComponent,
  },
  {
    title: "Yes7 - Quem Somos",
    path: "about-us",
    component: AboutUsComponent,
  },
  {
    title: "Yes7 - Termos e condições de uso",
    path: "terms-of-use",
    component: TermsOfUseComponent,
  },
  {
    title: "Yes7 - Meia Entrada",
    path: "half-price",
    component: HalfPriceComponent,
  },
  {
    title: "Yes7 - Perguntas frequentes",
    path: "frequently-asked-questions",
    component: FrequentlyAskedQuestionsComponent,
  },
  {
    title: "Yes7 - Fale Conosco",
    path: "talk-to-us",
    component: TalkToUsComponent,
  },
  {
    title: "Yes7 - Aceitar convite colaborador",
    path: "collaborators/accept",
    component: CollaboratorsAcceptanceComponent,
    canActivate: [authGuard],
  },
  {
    title: "Yes7 - Criar Evento",
    path: "create-event",
    component: CreateEventContainerComponent,
    canActivate: [authGuard],
  },
  {
    title: "Yes7 - Editar Evento",
    path: "edit-event/:id",
    component: EditEventContainerComponent,
    canActivate: [authGuard, hasAccessGuard],
  },
  {
    title: "Yes7 - Meus Eventos Favoritos",
    path: "favorite-events",
    component: MyFavoriteEventsContainerComponent,
    canActivate: [authGuard],
  },
  {
    title: "Yes7 - Meus Eventos",
    path: "my-events",
    component: MyEventsPageComponent,
    canActivate: [authGuard],
  },
  {
    title: "Yes7 - Carteira",
    path: "wallet",
    component: WalletComponent,
    canActivate: [authGuard],
  },
  {
    title: "Yes7 - Meus cartões",
    path: "my-cards",
    component: ManageCardsComponent,
    canActivate: [authGuard],
  },
  {
    title: "Yes7 - Resumo Geral",
    path: "producer-area",
    component: ProducerAreaComponent,
    canActivate: [authGuard],
  },
  {
    title: "Yes7 - Detalhes do evento",
    path: "producer-area/event/:id",
    component: ProducerEventPageComponent,
    canActivate: [authGuard, hasAccessGuard],
    // canActivate: [roleGuard],
    // data: { role: "doorperson" },
  },
  {
    title: "Yes7 - Solicitações",
    path: "solicitations",
    component: SolicitationsPageComponent,
    canActivate: [authGuard],
  },
  {
    title: "Yes7 - Detalhes da Solicitação",
    path: "solicitations/:id",
    component: SolicitationDetailPageComponent,
    canActivate: [authGuard],
  },
  {
    title: "Yes7 - Suporte",
    path: "support",
    component: SupportPageComponent,
    canActivate: [authGuard],
  },
  {
    title: "Yes7 - Detalhes do Chamado",
    path: "support/:id",
    component: SupportDetailPageComponent,
    canActivate: [authGuard],
  },
  {
    path: "coupons",
    redirectTo: "producer-area",
    pathMatch: "full",
  },
  {
    title: "Yes7 - Detalhes do Cupom",
    path: "coupons/:id",
    component: CouponDetailPageComponent,
    canActivate: [authGuard],
  },
  {
    title: "Yes7 - Minha Página",
    path: "my-page",
    component: CreateProducersPageComponent,
    canActivate: [authGuard],
  },
  {
    title: "Yes7 - Meus convites",
    path: "my-invitations",
    component: MyInvitationsPageComponent,
    canActivate: [authGuard],
  },
  {
    title: "Yes7 - Notificações",
    path: "notifications",
    component: NotificationsPageComponent,
    canActivate: [authGuard],
  },
  {
    title: "Yes7 - Minhas vendas",
    path: "my-sales",
    component: MySalesPageComponent,
    canActivate: [authGuard],
  },
  {
    title: "Yes7 - Eventos para venda",
    path: "seller-events",
    component: SellerEventsPageComponent,
    canActivate: [authGuard],
  },
  {
    title: "Yes7 - Minhas vendas",
    path: "seller-orders",
    component: SellerOrdersPageComponent,
    canActivate: [authGuard],
  },
  {
    title: "Yes7 - Produtos seguidos",
    path: "followed-producers",
    component: FollowedProducersPageComponent,
    canActivate: [authGuard],
  },
  {
    title: "Yes7 - Convite Confirmado",
    path: "collaborator-success/:eventId",
    component: CollaboratorsInvitationSuccessPageComponent,
    canActivate: [authGuard],
  },
  {
    title: "Yes7 - Finalizar Cadastro",
    path: "finish-signup",
    component: FinishSignUpPageComponent,
  },
  {
    title: "Yes7 - Eventos",
    path: "all-events",
    component: EventsListContainerComponent,
  },
  { path: "login", redirectTo: "" },
  {
    title: "Yes7 - Página não encontrada",
    path: "page-not-found",
    component: PageNotFoundComponent,
  },
  {
    title: "Yes7 - Página do Produtor",
    path: ":organizer_page",
    component: ProducersPageComponent,
    resolve: { organizer: organizerResolver },
  },
  { path: "**", component: PageNotFoundComponent },
];
